module.exports = __webpack_public_path__ + "static/img/service-1.dc01cb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service-1.png
// module id = hB4Y
// module chunks = 1